/** src/components/Projects.js */

// Extend ProjectTabs to show an 'All Documents' tab and track selected tab

import { useEffect, useState } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import { PlusIcon } from '@heroicons/react/24/solid';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export default function ProjectTabs({ collections, setCollections, selectedCollection, setSelectedCollection, onOpenProjectDialog }) {
  const [newProject, setNewProject] = useState({ title: '', objective: '', rss: '' });

  /* const handleCreateProject = async (e) => {
    e.preventDefault();
    try {
      const rssList = newProject.rss
        .split(/\s+/)
        .map(url => url.trim())
        .filter(Boolean);

      const res = await axios.post(`${API_URL}/api/projects`, {
        title: newProject.title,
        objective: newProject.objective,
        rss: rssList
      });
      setCollections(prev => [...prev, res.data]);
      setSelectedCollection(res.data.id);
      setNewProject({ title: res.data.title, objective: res.data.objective, rss: res.data.rss_urls });
      setShowCreateDossierDialog(false);
    } catch (err) {
      alert('Failed to create project: ' + err);
    }
  }; */

  return (
    <Tabs.Root value={selectedCollection} onValueChange={setSelectedCollection}>
      <Tabs.List className="flex border-b items-center">
        {collections && collections.map((col) => (
          <Tabs.Trigger
            key={col.id}
            value={col.id}
            className="px-4 py-2 text-sm font-medium data-[state=active]:border-b-2 border-blue-500"
            title={col.objective}
          >
            {col.title}
          </Tabs.Trigger>
        ))}
        <button onClick={() => onOpenProjectDialog()} className="ml-2 p-1 text-blue-500 hover:text-blue-700">
          <PlusIcon className="w-5 h-5" />
        </button>
      </Tabs.List>

      {/* showDialog && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-lg w-full max-w-xl">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Create New Dossier</h2>
              <button
                onClick={() => setShowCreateDossierDialog(false)}
                className="text-gray-500 hover:text-gray-800 text-xl"
              >
                &times;
              </button>
            </div>
            <form onSubmit={handleCreateProject} className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1">Dossier Title</label>
                <input
                  type="text"
                  required
                  className="w-full border px-3 py-2 rounded"
                  value={newProject.title}
                  onChange={(e) => setNewProject(prev => ({ ...prev, title: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Objective Description</label>
                <textarea
                  required
                  rows={2}
                  className="w-full border px-3 py-2 rounded"
                  value={newProject.objective}
                  onChange={(e) => setNewProject(prev => ({ ...prev, objective: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">RSS URLs (one per line)</label>
                <textarea
                  rows={4}
                  className="w-full border px-3 py-2 rounded"
                  value={newProject.rss}
                  onChange={(e) => setNewProject(prev => ({ ...prev, rss: e.target.value }))}
                />
              </div>
              <div className="text-sm text-gray-400 italic -mt-2 text-center w-full">
                You can edit this information later from the Dossier tab.
              </div>
              <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded">
                Create Dossier
              </button>
            </form>
          </div>
        </div>
      )*/}
    </Tabs.Root>
  );
}

// Add at the bottom of Projects.js
export function NewProjectDialogContent({ newProject, setNewProject, handleCreateProject, onClose }) {
  return (
    <>
      <form onSubmit={handleCreateProject} className="grid grid-cols-1 gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Dossier Title</label>
          <input
            type="text"
            required
            className="w-full border px-3 py-2 rounded"
            value={newProject.title}
            onChange={(e) => setNewProject(prev => ({ ...prev, title: e.target.value }))}
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Objective Description</label>
          <textarea
            required
            rows={5}
            className="w-full border px-3 py-2 rounded"
            value={newProject.objective}
            onChange={(e) => setNewProject(prev => ({ ...prev, objective: e.target.value }))}
          />
        </div>
        {/* <div>
          <label className="block text-sm font-medium mb-1">RSS URLs (one per line)</label>
          <textarea
            rows={4}
            className="w-full border px-3 py-2 rounded"
            value={newProject.rss}
            onChange={(e) => setNewProject(prev => ({ ...prev, rss: e.target.value }))}
          />
        </div> */}
        <div className="text-sm text-gray-400 italic -mt-2 text-center w-full">
          You can edit this information later from the Dossier tab.
        </div>
        <button type="submit" className="bg-blue-600 text-white py-2 px-4 rounded">
          Create Dossier
        </button>
      </form>
    </>
  );
}